export enum DesignLevel {
    Organization = 'Organization',
    Workspace = 'Workspace',
    Template = 'Template',
    Submittable = 'Submittable',
    Merge = 'Merge'
}
